import { apiClient } from '../client/apiClient';
import type { FetchByCoordsParams, FetchByCoordsResponse } from './listing';

/**
 * Fetch listings within the specified map bounds (coordinates).
 *
 * This is the primary endpoint for the Search Results Page to load listings
 * visible in the current map viewport, and feeds the homepage carousels.
 *
 * Lives apart from `./listing` so those consumers don't bundle the full
 * listing-detail endpoint module; the request/response types stay in
 * `./listing` (type imports are erased at compile time).
 */
export const fetchByCoords = async (
  params: FetchByCoordsParams,
  signal?: AbortSignal,
): Promise<FetchByCoordsResponse> => {
  const response = await apiClient<{ data: FetchByCoordsResponse }>({
    path: '/v2/listing/byCoordsV2',
    queryParams: {
      ...params,
      trimResponse: params.trimResponse ?? true,
    },
    signal,
  });
  return response.data;
};
